import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-[#110038] py-24 md:py-32 relative overflow-hidden" data-id="element-173">
      {/* Purple Mesh Gradient Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-174">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[#7C3AED] opacity-20 blur-[120px]" data-id="element-175"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-[#4C1D95] opacity-30 blur-[150px]" data-id="element-176"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-177">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-12" data-id="element-178">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 text-center md:text-left order-1" data-id="element-179">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight font-serif" data-id="element-180">
              Cómo salvar tu relación y recuperar la{' '}
              <span className="text-[#E5A83B]" data-id="element-181">Paz Mental</span>...
              <br data-id="element-182" />
              <span className="text-3xl md:text-4xl italic opacity-90 mt-3 block" data-id="element-183">
                incluso si sentís que ya lo intentaste todo.
              </span>
            </h1>

            <p className="text-sm md:text-base text-[#C4B5FD] font-bold tracking-wide uppercase mb-6 font-sans flex items-center justify-center md:justify-start gap-2" data-id="element-184">
              <span className="text-lg" data-id="element-185">👉</span> 20 páginas. Sin relleno. Solo
              el protocolo exacto para los próximos 7 días.
            </p>

            <p className="text-lg md:text-xl text-[#A78BFA] mb-10 leading-relaxed font-sans" data-id="element-186">
              Descubrí el <strong data-id="element-187">método práctico</strong> para reconstruir la
              comunicación, <em data-id="element-188">sanar heridas</em> y{' '}
              <strong data-id="element-189">blindar tu pareja</strong> contra las crisis financieras y
              el agotamiento mental.
            </p>

            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(124, 58, 237, 0)', '0 0 0 15px rgba(124, 58, 237, 0.2)', '0 0 0 0 rgba(124, 58, 237, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="inline-block w-full md:w-auto bg-[#7C3AED] text-white px-8 py-5 rounded-lg text-lg font-semibold shadow-[0_10px_25px_-5px_rgba(124,58,237,0.5)] hover:bg-[#6D28D9] transition-colors mb-6 text-center font-sans tracking-wide" data-id="element-190">
              SÍ, QUIERO SALVAR MI RELACIÓN
            </motion.a>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 text-xs md:text-sm text-[#C4B5FD] font-sans mb-8" data-id="element-191">
              <div className="flex items-center gap-1.5" data-id="element-192">
                <DownloadIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-193" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-194">
                <ShieldCheckIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-195" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-196">
                <FileTextIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-197" />
                PDF
              </div>
            </div>

            <div className="text-center md:text-left text-[#A78BFA] text-sm animate-bounce mt-4" data-id="element-198">
              👇 <em data-id="element-199">Seguí leyendo para ver cómo funciona...</em>
            </div>
          </motion.div>

          {/* Right: Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 flex justify-center order-2 perspective-1000" data-id="element-200">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full max-w-[400px] flex justify-center" data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/1otX3pN3jAid8E1pjbZi1A/48g9UqSEtBv4jUvrnliaY.png" alt="Rescate de Pareja: Libro" className="w-full max-w-[320px] h-auto rounded-md transform -rotate-6" style={{
              boxShadow: '-20px 25px 50px rgba(0, 0, 0, 0.6), inset 2px 0 5px rgba(255,255,255,0.2)'
            }} data-id="element-202" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}